import React from 'react';
import { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { Button } from 'primereact/button';
import { Tag } from 'primereact/tag';
import { Timeline } from 'primereact/timeline';
import { Card } from 'primereact/card';

export default function Home() {
    const navigate = useNavigate();
    const [gitHubData, setGitHubData] = useState(null);

    useEffect(() => {
        async function fetchData() {
            try {
                const response = await fetch('https://api.github.com/users/vishalbhuva666/repos', {
                    headers: {
                        'Authorization': `token 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`
                    }
                });
                if (!response.ok) {
                    throw new Error('Network response was not ok ' + response.statusText);
                }
                const data = await response.json();
                setGitHubData(data);
            } catch (error) {
                console.error('There has been a problem with your fetch operation:', error);
            }
        }
        fetchData();
    })

    const std = [
        {
            name: "HSC",
            icon: 'pi pi-graduation-cap',
            cgpa: "93.48",
            Location: "Vivekanand School Babra",
            year: "2016/2018",
            color: '#607D8B'
        },
        {
            name: "BCA",
            icon: 'pi pi-graduation-cap',
            cgpa: "8.6",
            Location: "Saurashtra University Rajkot",
            year: "2018/2021",
            color: '#607D8B'
        },
        {
            name: "MCA",
            icon: 'pi pi-graduation-cap',
            cgpa: "9.0",
            Location: "R.K University Rajkot",
            year: "2021/2022",
            color: '#607D8B'
        }
    ];

    const customizedMarker = (item) => {
        return (
            <span className="flex w-2rem h-2rem align-items-center justify-content-center text-white border-circle z-1 shadow-1" style={{ backgroundColor: item.color }}>
                <i className={item.icon}></i>
            </span>
        );
    };

    const customizedContent = (item) => {
        return (
            <Card className='shadow-none' style={{ backgroundColor: 'transparent' }} title={item.name} subTitle={item.year}>
                <Tag style={{ backgroundColor: 'rgb(96, 125, 139)' }} className="mr-2 w-5rem m-0" severity='' value={`${item.cgpa} ${item.name == "HSC" ? '%' : 'CGPA'}`}></Tag>
                <p className='text-xs'>{item?.Location}</p>
            </Card>
        )
    };

    function github() {
        window.open("https://github.com/vishalbhuva666");
    };

    function linkedin() {
        window.open("https://www.linkedin.com/in/vishal-ahir-52575a17b/");
    };

    function website() {
        window.open("https://primereactdemo.netlify.app/");
    };

    function githubJquery(item) {
        window.open(item);
    };

    return (
        <>
            <div class="flex center-container px-5 py-2">
                <div class="col-12 md:col-4 lg:col-4">
                    <div style={{ background: '#E3E3ED' }} class="text-center p-3 border-round-3xl mb-3">
                        <img class="profile-img" src={require('../image/10.jpg')}></img>
                        <h5 class="font-bold text-2xl my-2"><span class="text-base-content opacity-70">Bhuva Vishal</span></h5>
                        <div class="mt-3 text-base-content text-opacity-60 font-mono text-500">⚡ Software Devloper | SharePoint(Spfx/react) | Node.js | React | PHP | JavaScript ⚡</div>
                        <Button className='mt-5 mb-3 shadow-none p-button p-component p-button-outlined p-button-secondary p-2 border-round-3xl' label="Download Resume" severity="secondary" outlined />
                    </div>
                    <div style={{ background: '#E3E3ED' }} class="text-center p-3 border-round-3xl my-3">
                        <div class="text-base-content text-opacity-60 font-mono text-500 flex justify-content-between align-items-center px-3">
                            <div className='flex align-items-center'><i className="pi pi-map-marker mr-2" style={{ color: '#708090' }}></i> Based in:</div>
                            <div>india</div>
                        </div>
                        <div class="text-base-content text-opacity-60 font-mono text-500 flex justify-content-between align-items-center px-3 my-3">
                            <div className='flex align-items-center'><i className="pi pi-github mr-2" style={{ color: '#708090' }}></i> GitHub:</div>
                            <div className='cursor-pointer' onClick={github}>vishalbhuva666</div>
                        </div>
                        <div class="text-base-content text-opacity-60 font-mono text-500 flex justify-content-between align-items-center px-3 my-3">
                            <div className='flex align-items-center'><i className="pi pi-linkedin mr-2" style={{ color: '#708090' }}></i> LinkedIn:</div>
                            <div className='cursor-pointer' onClick={linkedin}>linkedin</div>
                        </div>
                        <div class="text-base-content text-opacity-60 font-mono text-500 flex justify-content-between align-items-center px-3 my-3">
                            <div className='flex align-items-center'><i className="pi pi-envelope mr-2" style={{ color: '#708090' }}></i> Email:</div>
                            <div>vbhuva358@rku.ac.in</div>
                        </div>
                        <div class="text-base-content text-opacity-60 font-mono text-500 flex justify-content-between align-items-center px-3 mt-3">
                            <div className='flex align-items-center'><i className="pi pi-link mr-2" style={{ color: '#708090' }}></i> Website:</div>
                            <div className='cursor-pointer' onClick={website}>https://primereactdemo.netlify.app/</div>
                        </div>
                    </div>
                    <div style={{ background: '#E3E3ED' }} class="text-center p-3 border-round-3xl mb-3">
                        <div class="text-base-content text-opacity-60 font-mono text-500">⚡ Education ⚡</div>
                        <Timeline value={std} align="alternate" className="customized-timeline mt-3" marker={customizedMarker} content={customizedContent} />
                    </div>
                    <div style={{ background: '#E3E3ED' }} class="text-center p-3 border-round-3xl my-3">
                        <div class="text-base-content text-opacity-60 font-mono text-500">⚡  Skills  ⚡</div>
                        <div className='flex flex-wrap justify-content-center my-3'>
                            <Tag className='w-5rem mx-2 my-1 text-black-alpha-70' value="SharePoint"></Tag>
                            <Tag className='w-5rem mx-2 my-1' severity="success" value="React"></Tag>
                            <Tag className='w-5rem mx-2 my-1 text-black-alpha-70' severity="info" value="JavaScript"></Tag>
                            <Tag className='w-5rem mx-2 my-1' severity="danger" value="CSS"></Tag>
                            <Tag className='w-5rem mx-2 my-1 text-black-alpha-70' severity="secondary" value="PHP"></Tag>
                            <Tag className='w-5rem mx-2 my-1' severity="warning" value="HTML"></Tag>
                            <Tag className='w-6rem mx-2 my-1 text-black-alpha-70' severity="contrast" value="Spfx Pnp/js"></Tag>
                            <Tag className='w-6rem mx-2 my-1' severity="contrast" value='MYSQL'></Tag>
                            <Tag className='w-5rem mx-2 my-1 text-black-alpha-70' value="JQuery"></Tag>
                            <Tag className='w-9rem mx-2 my-1' severity="success" value="Boostrap/PrimeReact"></Tag>
                            <Tag className='w-5rem mx-2 my-1 text-black-alpha-70' severity="warning" value="Node/Js"></Tag>
                            <Tag className='w-5rem mx-2 my-1' severity="info" value="Node/Js"></Tag>
                            <Tag className='w-5rem mx-2 my-1 text-black-alpha-70' severity="danger" value="MongoDb"></Tag>
                        </div>
                    </div>
                    <div style={{ background: '#E3E3ED' }} class="text-center p-3 border-round-3xl mb-3">
                        <div class="text-base-content text-opacity-60 font-mono text-500">⚡ Experience  ⚡</div>
                        <div class="text-base-content text-opacity-60 font-mono text-500 flex align-items-center px-3 my-3">
                            <div className='flex align-items-center'><i className="pi pi-building mr-2" style={{ color: '#708090' }}></i> SharePoint Empower</div>
                        </div>
                        <div class="text-base-content text-opacity-60 font-mono text-500 flex align-items-center px-3 my-3">
                            <div className='flex align-items-center'><i className="pi pi-id-card mr-2" style={{ color: '#708090' }}></i> July 2022 - Present</div>
                        </div>
                        <div class="text-base-content text-opacity-60 font-mono text-500 flex align-items-center px-3 my-3">
                            <div className='flex align-items-center'><i className="pi pi-briefcase mr-2" style={{ color: '#708090' }}></i> Software Developer</div>
                        </div>
                    </div>
                </div>
                <div class="col-12 md:col-8 lg:col-8" >
                    <div class="col-12 md:col-12 lg:col-12 text-center p-3 border-round-3xl mb-3" style={{ background: '#e5e7eb' }} >
                        {gitHubData?.map((item) => {
                            return (<div onClick={() => githubJquery(item?.svn_url)} style={{ background: '#E3E3ED' }} class="text-center p-3 border-round-3xl mb-3 col-12 md:col-6 lg:col-6 cursor-pointer" >
                                <h5 class="font-bold text-2xl my-2"><span class="text-base-content opacity-70">{item?.name}</span></h5>
                                <Button className='mt-5 mb-3 shadow-none p-button p-component p-button-outlined p-button-secondary p-2 border-round-3xl' icon='pi pi-star' label={JSON?.stringify(item?.watchers)} severity="secondary" outlined />
                                <Button className='mt-5 mb-3 shadow-none p-button p-component p-button-outlined p-button-secondary p-2 border-round-3xl ml-3' icon='pi pi-sitemap' label={JSON.stringify(item?.forks)} severity="secondary" outlined />
                            </div>
                            )
                        })}
                    </div>
                </div>
            </div >
        </>
    );
}
